import { VUE_APP_PHARMSNAP_MF_PDF_PATH } from '@pharmsnap/pharmsnap-web/config'
import { i18n } from 'pharmsnapMF_shared/i18n'

export function getPdfUrl(pdfSrc: string, page?: string): string {
  let url = `${VUE_APP_PHARMSNAP_MF_PDF_PATH}/generic-legacy/web/viewer.html?file=${encodeURIComponent(pdfSrc)}#locale=${
    i18n.locale
  }&disablerange=true`
  if (page) {
    url += `&page=${page}`
  }
  return url
}
